// Novidades do HUB: o que mudou, para quem, e quem já viu (visto «Li e percebi»).
// Publicam a Cátia e o Tiago; cada destinatário tem 5 dias úteis para ver, depois recebe um lembrete.
export const PRAZO_NOVIDADES = 5;
export const PUBLICOS = [['todos', 'Todos'], ['comercial', 'Comercial'], ['operations', 'Operações'], ['tl', 'TL'], ['financial', 'Financeiro'], ['admin', 'Administração']];
export const nomePublico = (k) => (PUBLICOS.find(x => x[0] === k) || [k, k])[1];
export const paraMim = (n, role) => { const p = Array.isArray(n.publico) && n.publico.length ? n.publico : ['todos']; return p.includes('todos') || p.includes(role); };

export function diasUteisDesde(isoTs) {
  if (!isoTs) return 0;
  const d = new Date(isoTs); d.setHours(12, 0, 0, 0);
  const h = new Date(); h.setHours(12, 0, 0, 0);
  let n = 0;
  while (d < h) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w > 0 && w < 6) n++; }
  return n;
}

// novidades que esta pessoa ainda não viu (para o menu e o Resumo de pendentes)
export async function novidadesPorVer(supabase, email, role) {
  try {
    const eu = String(email || '').toLowerCase();
    if (!eu) return [];
    const [{ data: ns, error }, { data: vs }] = await Promise.all([
      supabase.from('hub_novidades').select('id,titulo,modulo,publico,publicada_em,link').eq('ativo', true).order('publicada_em', { ascending: false }).limit(200),
      supabase.from('hub_novidades_vistos').select('novidade_id').ilike('email', eu),
    ]);
    if (error) return [];
    const vistos = new Set((vs || []).map(v => v.novidade_id));
    return (ns || []).filter(n => paraMim(n, role) && !vistos.has(n.id));
  } catch (_) { return []; }   // tabelas ainda não criadas
}

export const avisarMudanca = () => { try { window.dispatchEvent(new Event('novidades-mudaram')); } catch (_) { /* */ } };
